import { Box, Inline, Stack, Text } from '@/ui';
import type { ReactElement } from 'react';

type MetricSubsectionProps = {
  title: string;
  description?: string;
  headerAccessory?: ReactElement;
  children: ReactElement;
};

export const MetricSubsection = ({
  title,
  description,
  headerAccessory,
  children,
}: MetricSubsectionProps): ReactElement => (
  <Stack gap="md">
    <Stack gap={description ? 'xxs' : 'none'}>
      <Inline justify="space-between" align="center" wrap="nowrap">
        <Text role="body">{title}</Text>
        {headerAccessory ?? <Box />}
      </Inline>
      {description ? (
        <Text role="caption" color="textSecondary">
          {description}
        </Text>
      ) : null}
    </Stack>
    {children}
  </Stack>
);
